
import { CheckCircle } from 'lucide-react';
import { usePayment } from '@/context/PaymentContext';

const PaymentSummary = () => {
  const { packageType, getOriginalAmount, finalAmount, discount } = usePayment();

  return (
    <>
      <div className="rounded-lg bg-gray-50 p-4 mb-6">
        <div className="flex items-center mb-2">
          <CheckCircle className="h-5 w-5 text-green-500 mr-2" />
          <h2 className="text-lg font-semibold">
            {packageType === 'silver' ? 'Silver Package' : 'Gold Package'}
          </h2>
        </div>
        <p className="text-gray-600 ml-7">
          {packageType === 'silver' 
            ? 'Career Assessment Test & Personalized Report' 
            : 'Assessment, Report & Expert Consultation'}
        </p>
      </div>

      <div className="space-y-3">
        <div className="flex justify-between items-center">
          <span className="text-gray-600">Package Price:</span>
          <span className="font-medium">₹{getOriginalAmount()}</span>
        </div>

        {discount > 0 && (
          <div className="flex justify-between items-center text-green-600">
            <span>Discount:</span>
            <span>-₹{discount}</span>
          </div>
        )}
      </div>

      <div className="border-t pt-4 mt-4">
        <div className="flex justify-between items-center font-bold text-lg">
          <span>Total Amount:</span>
          <span>₹{finalAmount}</span>
        </div>
      </div>
    </>
  );
};

export default PaymentSummary;
